


// before 13-7-2026

// import {
//   Button, TextField, IconButton, InputAdornment,
//   CircularProgress, Checkbox, FormControlLabel,
//   Fade,
// } from '@mui/material';
// import React, { useEffect, useState } from 'react';
// import Container from 'react-bootstrap/esm/Container';
// import Row from 'react-bootstrap/esm/Row';
// import DoneIcon from '@mui/icons-material/Done';
// import Visibility    from '@mui/icons-material/Visibility';
// import VisibilityOff from '@mui/icons-material/VisibilityOff';
// import { useDispatch, useSelector } from 'react-redux';
// import { Login_Actionn } from '../../Redux/Actions/AuthAction';
// import { Notify }        from '../../Utility/Notify';
// import { Add_User_Activation_Action } from '../../Redux/Actions/User_Activation_Action';
// import {
//   isMobile, isTablet, isDesktop,
//   browserName, engineName, osName,
// } from 'react-device-detect';
// import axios   from 'axios';
// import logo    from '../../images/Realatix_Black.png';
// import { useTheme } from '@mui/material/styles';
// import '../../../src/Login.css';
// import { getToken }      from 'firebase/messaging';
// import { initializeApp } from 'firebase/app';
// import { getMessaging }  from 'firebase/messaging';
// import baseurl from '../../Api/BaseUrl';

// const firebaseConfig = {
//   apiKey:            'AIzaSyC7MKQ4GCj46rDtyVxMw-0W1kEHMjzrzj8',
//   authDomain:        'homewalkers-1df5a.firebaseapp.com',
//   projectId:         'homewalkers-1df5a',
//   storageBucket:     'homewalkers-1df5a.firebasestorage.app',
//   messagingSenderId: '107479182425',
//   appId:             '1:107479182425:web:0d46013d3c542dbb881548',
//   measurementId:     'G-M8ZFNZ4XLM',
// };

// const app = initializeApp(firebaseConfig);
// export const messaging = getMessaging(app);

// // ── helper: بيجيب unique ID للمتصفح/الجهاز ───────────────────────────────
// const getDeviceId = () => {
//   let id = localStorage.getItem('_deviceId');
//   if (!id) {
//     id = 'web-' + Math.random().toString(36).slice(2) + '-' + Date.now().toString(36);
//     localStorage.setItem('_deviceId', id);
//   }
//   return id;
// };

// export const Login = () => {
//   const theme = useTheme();
//   const mode  = theme.palette.mode;

//   const [showPassword, setShowPassword] = useState(false);
//   const handleClickShowPassword = () => setShowPassword(!showPassword);
//   const handleMouseDownPassword = (e) => e.preventDefault();

//   const [location,   setLocation]   = useState(null);
//   const [isLoggedIn, setIsLoggedIn] = useState(false);
//   const [isLoading,  setIsLoading]  = useState(true);
//   const [isLoading2, setIsLoading2] = useState(false);
//   const [staySignedIn, setStaySignedIn] = useState(false);
//   const [email,    setEmail]    = useState('');
//   const [password, setPassword] = useState('');
//   const [user,     setUser]     = useState('');

//   const dispatch    = useDispatch();
//   const resLogin    = useSelector(state => state.AuthRoot.Signup);
//   const resAddLogin = resLogin?.data || [];

//   useEffect(() => {
//     const fetchLocation = async () => {
//       try {
//         const response = await axios.get('https://ipinfo.io/json?token=e95a1c99775abd');
//         setLocation(response.data);
//       } catch (error) {
//         console.error('Error fetching location data:', error);
//       }
//     };
//     fetchLocation();
//   }, []);

//   const submitUser = async (e) => {
//     e.preventDefault();

//     // ── 1. جيب الـ FCM token + deviceId ─────────────────────────────────────
//     let fcmToken = '';
//     let platform = 'web';
//     const deviceId = getDeviceId();

//     try {
//       await Notification.requestPermission();
//       fcmToken = await getToken(messaging, {
//         vapidKey: 'BOnV3OPr8NtdAAFOblZEihI98FMCCn0jC_t_lkdAZ6h2brGdh2eHt6BjFeDTm8pE1YGYtbE_0EGThXUZR6XpTc4',
//       });
//       if (fcmToken) {
//         localStorage.setItem('fcmToken',  fcmToken);
//         localStorage.setItem('_deviceId', deviceId);
//       } else {
//         console.warn('⚠️ FCM token not retrieved');
//       }
//     } catch (error) {
//       console.error('❌ Failed to get FCM token:', error);
//     }

//     setIsLoading(true);
//     setIsLoading2(true);

//     await dispatch(Login_Actionn({
//       email,
//       password,
//       fcmToken,
//       deviceId,
//       platform,
//     }));

//     setIsLoading(false);
//     setIsLoading2(false);

//     baseurl
//       .post('/api/v1/Signup/login', { email, password, fcmToken })
//       .then(res => {
//         if (res.data?.data?.active === false) {
//           Notify('error', '🚫 Your account has been deactivated. Please contact administration.', 'error');
//         }
//       })
//       .catch(err => {
//         console.error('❌ Error:', err.response?.data || err.message);
//       });
//   };

//   useEffect(() => {
//     if (!isLoading && resLogin?.status === 200) {
//       if (resLogin?.data?.token) {
//         localStorage.setItem('token',    resLogin?.data?.token);
//         localStorage.setItem('user',     JSON.stringify(resLogin?.data));
//         localStorage.setItem('userRole', JSON.stringify(resLogin?.data));
//       }
//       if (resLogin?.data) {
//         if (JSON.parse(localStorage.getItem('user')) != null) {
//           setUser(JSON.parse(localStorage.getItem('user')));
//         }
//         localStorage.setItem('userRole', JSON.stringify(resLogin?.data));
//         localStorage.setItem('deviceId', resLogin?.data?.deviceId);
//         const savedDeviceId = localStorage.getItem('deviceId');
//         console.log('📱 DeviceId saved in localStorage:', savedDeviceId);

//         Notify('success', 'Login Successful', 'success');
//         setEmail('');
//         setPassword('');
//         setIsLoggedIn(true);
//         localStorage.setItem('isLoggedIn', 'true');

//         const userRole = resAddLogin?.data?.role;
//         const redirectPaths = {
//           'Admin':       '#/dashboard',
//           'Sales':       '#/AllLeadsForSales',
//           'Team Leader': '#/AllLeadsForTeamLeader',
//           'Manager':     '#/LeadsForManagers',
//           'Accountant':  '#/LeadsForAccountant',
//           'Marketer':    '#/ALLLeadsForMarketer',
//         };
//         if (userRole && redirectPaths[userRole]) {
//           setTimeout(() => {
//             window.location.href = redirectPaths[userRole];
//             window.location.reload();
//           }, 2500);
//         }
//       }
//     } else if (!isLoading && resLogin?.status === 403) {
//       localStorage.removeItem('token');
//       localStorage.removeItem('user');
//       const message = resLogin?.data?.message || 'Your account has been deactivated. Please contact the administrator';
//       Notify('error', message, 'error');
//     } else if (!isLoading && resLogin?.status !== 200) {
//       localStorage.removeItem('token');
//       localStorage.removeItem('user');
//       setEmail('');
//       setPassword('');
//       Notify('error', 'Login Failed', 'error');
//     }
//   }, [isLoading]);

//   useEffect(() => {
//     setIsLoggedIn(localStorage.getItem('isLoggedIn') === 'true');
//   }, []);

//   // ── JSX — نفس ديزاين الـ test model ──────────────────────────────────────
//   return (
//     <div className="login-wrapper">

//       {/* LEFT PANEL */}
//       <div className="login-left">
//         <div className="login-left-overlay" />
//         <div className="login-left-shapes">
//           <div className="ls ls1" /><div className="ls ls2" />
//           <div className="ls ls3" /><div className="ls ls4" />
//         </div>
//         <div className="login-left-content">
//           <div className="login-brand">
//             <img src={logo} alt="logo" style={{ width:'160px', height:'60px' }} />
//           </div>
//           <h1 className="login-hero-title">
//             Simple, fast, and secure CRM,<br />
//             for your customers, data, and sales<br />
//             Management.
//           </h1>
//         </div>
//         <p className="login-left-desc">
//           The digital concierge for the modern real estate executive.
//           Access your global portfolio with institutional-grade security.
//         </p>
//       </div>

//       {/* RIGHT PANEL */}
//       <div className="login-right">
//         <div className="login-form-area">
//           <h2 className="login-title">Welcome Back</h2>
//           <p className="login-subtitle">Please enter your credentials to access the workspace.</p>

//           {/* EMAIL */}
//           <label className="login-field-label">Email Address</label>
//           <TextField
//             value={email}
//             onChange={e => setEmail(e.target.value)}
//             type="email"
//             placeholder="name@company.com"
//             variant="outlined"
//             fullWidth
//             className="login-textfield"
//             InputProps={{
//               startAdornment: (
//                 <InputAdornment position="start">
//                   <span className="login-at-icon">@</span>
//                 </InputAdornment>
//               ),
//             }}
//           />

//           {/* PASSWORD */}
//           <div className="login-pw-header">
//             <label className="login-field-label" style={{ margin:0 }}>Password</label>
//           </div>
//           <TextField
//             value={password}
//             onChange={e => setPassword(e.target.value)}
//             type={showPassword ? 'text' : 'password'}
//             variant="outlined"
//             fullWidth
//             className="login-textfield"
//             InputProps={{
//               startAdornment: (
//                 <InputAdornment position="start">
//                   <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ opacity:0.5 }}>
//                     <rect x="3" y="11" width="18" height="11" rx="2"/>
//                     <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
//                   </svg>
//                 </InputAdornment>
//               ),
//               endAdornment: (
//                 <InputAdornment position="end">
//                   <IconButton
//                     onClick={handleClickShowPassword}
//                     onMouseDown={handleMouseDownPassword}
//                     edge="end" size="small"
//                   >
//                     {showPassword ? <VisibilityOff fontSize="small"/> : <Visibility fontSize="small"/>}
//                   </IconButton>
//                 </InputAdornment>
//               ),
//             }}
//           />

//           {/* STAY SIGNED IN */}
//           <FormControlLabel
//             className="login-check-row"
//             control={
//               <Checkbox
//                 checked={staySignedIn}
//                 onChange={e => setStaySignedIn(e.target.checked)}
//                 size="small"
//                 sx={{ color:'#b0b8c9', '&.Mui-checked':{ color:'#0d2a6e' } }}
//               />
//             }
//             label={<span className="login-check-label">Stay signed in for 30 days</span>}
//           />

//           {/* SUBMIT */}
//           <Button
//             onClick={submitUser}
//             variant="contained"
//             fullWidth
//             disabled={isLoading2}
//             className="login-cta-btn"
//             endIcon={isLoading2 ? null : <span>→</span>}
//             startIcon={isLoading2 ? <CircularProgress size={18} sx={{ color:'#fff' }}/> : null}
//           >
//             {isLoading2 ? 'Logging in...' : 'ACCESS WORKSPACE'}
//           </Button>

//           <div className="login-divider" />
//           <div className="login-bottom-links" />
//         </div>

//         <div className="login-footer">
//           <p>© 2026 REALATIX CRM. A perfectly structured CRM that effortlessly connects customer data with sales.</p>
//           <div className="login-footer-links">
//             <span>PRIVACY POLICY</span>
//             <span>TERMS OF SERVICE</span>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

























// after 13-7-2026
// test model
import {
  Button, TextField, IconButton, InputAdornment,
  CircularProgress, Checkbox, FormControlLabel,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import Visibility    from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { useDispatch, useSelector } from 'react-redux';
import { Login_Actionn } from '../../Redux/Actions/AuthAction';
import { Notify }        from '../../Utility/Notify';
import axios             from 'axios';
import logo              from '../../images/Realatix_Black.png';
import { getToken }      from 'firebase/messaging';
import { initializeApp } from 'firebase/app';
import { getMessaging }  from 'firebase/messaging';
import baseurl           from '../../Api/BaseUrl';

const firebaseConfig = {
  apiKey:            'AIzaSyC7MKQ4GCj46rDtyVxMw-0W1kEHMjzrzj8',
  authDomain:        'homewalkers-1df5a.firebaseapp.com',
  projectId:         'homewalkers-1df5a',
  storageBucket:     'homewalkers-1df5a.firebasestorage.app',
  messagingSenderId: '107479182425',
  appId:             '1:107479182425:web:0d46013d3c542dbb881548',
  measurementId:     'G-M8ZFNZ4XLM',
};

const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);

// ── helper: بيجيب unique ID للمتصفح/الجهاز ───────────────────────────────
const getDeviceId = () => {
  let id = localStorage.getItem('_deviceId');
  if (!id) {
    // بنعمل UUID بسيط — بيتخزن في localStorage ومبيتغيرش
    id = 'web-' + Math.random().toString(36).slice(2) + '-' + Date.now().toString(36);
    localStorage.setItem('_deviceId', id);
  }
  return id;
};

export const Login = () => {
  const [showPassword,  setShowPassword]  = useState(false);
  const [staySignedIn,  setStaySignedIn]  = useState(false);
  const [location,      setLocation]      = useState(null);
  const [isLoggedIn,    setIsLoggedIn]    = useState(false);
  const [isLoading,     setIsLoading]     = useState(true);
  const [isLoading2,    setIsLoading2]    = useState(false);
  const [email,         setEmail]         = useState('');
  const [password,      setPassword]      = useState('');

  const dispatch  = useDispatch();
  const resLogin  = useSelector(state => state.AuthRoot.Signup);
  const resAddLogin = resLogin?.data || [];

  useEffect(() => {
    const fetchLocation = async () => {
      try {
        const res = await axios.get('https://ipinfo.io/json?token=e95a1c99775abd');
        setLocation(res.data);
      } catch (e) { console.error('Location fetch failed:', e); }
    };
    fetchLocation();
  }, []);

  // ── Submit ─────────────────────────────────────────────────────────────────
  const submitUser = async (e) => {
    e.preventDefault();

    // ── 1. جيب الـ FCM token + info الجهاز ──────────────────────────────────
    let fcmToken = '';
    let platform = 'web';
    const deviceId = getDeviceId(); // unique per browser/device

    try {
      await Notification.requestPermission();
      fcmToken = await getToken(messaging, {
        vapidKey: 'BOnV3OPr8NtdAAFOblZEihI98FMCCn0jC_t_lkdAZ6h2brGdh2eHt6BjFeDTm8pE1YGYtbE_0EGThXUZR6XpTc4',
      });

      if (fcmToken) {
        // خزّن في localStorage للاستخدام وقت الـ logout
        localStorage.setItem('fcmToken',  fcmToken);
        localStorage.setItem('_deviceId', deviceId);
      } else {
        console.warn('⚠️ FCM token not retrieved');
      }
    } catch (err) {
      console.error('❌ Failed to get FCM token:', err);
    }

    // ── 2. بعت الـ login مع fcmToken + deviceId + platform ─────────────────
    setIsLoading(true);
    setIsLoading2(true);

    await dispatch(Login_Actionn({
      email,
      password,
      fcmToken,   // الـ backend يحطه في fcmTokens array
      deviceId,   // عشان يعرف يحدّث نفس الجهاز لو اتسجّل قبل كده
      platform,   // 'web'
    }));

    setIsLoading(false);
    setIsLoading2(false);
  };

  // ── useEffect: نتيجة الـ login ─────────────────────────────────────────────
  useEffect(() => {
    if (isLoading) return;

    if (resLogin?.status === 200) {
      if (resLogin?.data?.token) {
        localStorage.setItem('token', resLogin.data.token);
        localStorage.setItem('user',  JSON.stringify(resLogin.data));
      }

      Notify('success', 'Login Successful', 'success');
      setEmail('');
      setPassword('');
      setIsLoggedIn(true);
      localStorage.setItem('isLoggedIn', 'true');

      const userRole = resAddLogin?.data?.role;
      const redirectPaths = {
        'Admin':       '#/dashboard',
        'Sales':       '#/AllLeadsForSales',
        'Team Leader': '#/AllLeadsForTeamLeader',
        'Manager':     '#/LeadsForManagers',
        'Accountant':  '#/LeadsForAccountant',
        'Marketer':    '#/ALLLeadsForMarketer',
      };

      if (userRole && redirectPaths[userRole]) {
        setTimeout(() => {
          window.location.href = redirectPaths[userRole];
          window.location.reload();
        }, 2500);
      }

    } else if (resLogin?.status === 403) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      Notify('error', resLogin?.data?.message || 'Account deactivated. Contact admin.', 'error');
    } else if (resLogin?.status && resLogin.status !== 200) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      setEmail('');
      setPassword('');
      Notify('error', 'Login Failed', 'error');
    }
  }, [isLoading]);

  useEffect(() => {
    setIsLoggedIn(localStorage.getItem('isLoggedIn') === 'true');
  }, []);

  // ── JSX ────────────────────────────────────────────────────────────────────
  return (
    <div className="login-wrapper">

      {/* LEFT PANEL */}
      <div className="login-left">
        <div className="login-left-overlay" />
        <div className="login-left-shapes">
          <div className="ls ls1" /><div className="ls ls2" />
          <div className="ls ls3" /><div className="ls ls4" />
        </div>
        <div className="login-left-content">
          <div className="login-brand">
            <img src={logo} alt="logo" style={{ width:'160px', height:'60px' }} />
          </div>
          <h1 className="login-hero-title">
            Simple, fast, and secure CRM,<br />
            for your customers, data, and sales<br />
            Management.
          </h1>
        </div>
        <p className="login-left-desc">
          The digital concierge for the modern real estate executive.
          Access your global portfolio with institutional-grade security.
        </p>
      </div>

      {/* RIGHT PANEL */}
      <div className="login-right">
        <div className="login-form-area">
          <h2 className="login-title">Welcome Back</h2>
          <p className="login-subtitle">Please enter your credentials to access the workspace.</p>

          {/* EMAIL */}
          <label className="login-field-label">Email Address</label>
          <TextField
            value={email}
            onChange={e => setEmail(e.target.value)}
            type="email"
            placeholder="name@company.com"
            variant="outlined"
            fullWidth
            className="login-textfield"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <span className="login-at-icon">@</span>
                </InputAdornment>
              ),
            }}
          />

          {/* PASSWORD */}
          <div className="login-pw-header">
            <label className="login-field-label" style={{ margin:0 }}>Password</label>
          </div>
          <TextField
            value={password}
            onChange={e => setPassword(e.target.value)}
            type={showPassword ? 'text' : 'password'}
            variant="outlined"
            fullWidth
            className="login-textfield"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ opacity:0.5 }}>
                    <rect x="3" y="11" width="18" height="11" rx="2"/>
                    <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                  </svg>
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setShowPassword(!showPassword)}
                    onMouseDown={e => e.preventDefault()}
                    edge="end" size="small"
                  >
                    {showPassword ? <VisibilityOff fontSize="small"/> : <Visibility fontSize="small"/>}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          {/* STAY SIGNED IN */}
          <FormControlLabel
            className="login-check-row"
            control={
              <Checkbox
                checked={staySignedIn}
                onChange={e => setStaySignedIn(e.target.checked)}
                size="small"
                sx={{ color:'#b0b8c9', '&.Mui-checked':{ color:'#0d2a6e' } }}
              />
            }
            label={<span className="login-check-label">Stay signed in for 30 days</span>}
          />

          {/* SUBMIT */}
          <Button
            onClick={submitUser}
            variant="contained"
            fullWidth
            disabled={isLoading2}
            className="login-cta-btn"
            endIcon={isLoading2 ? null : <span>→</span>}
            startIcon={isLoading2 ? <CircularProgress size={18} sx={{ color:'#fff' }}/> : null}
          >
            {isLoading2 ? 'Logging in...' : 'ACCESS WORKSPACE'}
          </Button>

          <div className="login-divider" />

          <div className="login-bottom-links" />
        </div>

        <div className="login-footer">
          <p>© 2026 REALATIX CRM. A perfectly structured CRM that effortlessly connects customer data with sales.</p>
          <div className="login-footer-links">
            <span>PRIVACY POLICY</span>
            <span>TERMS OF SERVICE</span>
          </div>
        </div>
      </div>
    </div>
  );
};
